export default __webpack_public_path__ + "static/media/dtsd5168-3.c6284911.png";